import { User, Mail, LogOut, Settings, Crown } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import analytics from '../lib/tracking';

export default function UserProfile() {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    analytics.engagement('logout', 'auth');
    logout();
  };

  if (!user) {
    return null;
  }

  // Extract first name from email or use email
  const displayName = user.name || user.email.split('@')[0];

  return (
    <div className="p-6 space-y-6">
      {/* Profile Header */}
      <div className="text-center">
        <div className="w-20 h-20 bg-primary-pink rounded-full flex items-center justify-center mx-auto mb-4">
          <User className="w-10 h-10 text-white" />
        </div>
        <h2 className="text-text-dark text-xl font-semibold mb-1">
          {displayName}
        </h2>
        <p className="text-text-medium text-sm">
          {user.email}
        </p>
      </div>

      {/* Account Stats */}
      <div className="bg-pastel-purple bg-opacity-20 rounded-2xl p-4 border border-accent-pink">
        <h3 className="text-text-dark font-medium mb-3">Account Info</h3>
        <div className="space-y-2 text-sm">
          <div className="flex items-center justify-between">
            <span className="text-text-medium">Member since</span>
            <span className="text-text-dark font-medium">
              {new Date().toLocaleDateString()}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-text-medium">Account type</span>
            <div className="flex items-center gap-1">
              <Crown className="w-4 h-4 text-yellow-500" />
              <span className="text-text-dark font-medium">Member</span>
            </div>
          </div>
        </div>
      </div>

      {/* Menu Options */}
      <div className="space-y-3">
        <button className="w-full bg-white rounded-xl p-4 border border-accent-pink flex items-center gap-3 text-left transition-colors hover:bg-pastel-purple hover:bg-opacity-20">
          <Settings className="w-5 h-5 text-text-medium" />
          <div>
            <div className="text-text-dark font-medium">Settings</div>
            <div className="text-text-medium text-xs">Preferences and notifications</div>
          </div>
        </button>

        <button className="w-full bg-white rounded-xl p-4 border border-accent-pink flex items-center gap-3 text-left transition-colors hover:bg-pastel-purple hover:bg-opacity-20">
          <Mail className="w-5 h-5 text-text-medium" />
          <div>
            <div className="text-text-dark font-medium">Support</div>
            <div className="text-text-medium text-xs">Get help and contact us</div>
          </div>
        </button>
      </div>

      {/* Logout Button */}
      <button
        onClick={handleLogout}
        className="w-full bg-red-50 hover:bg-red-100 text-red-600 rounded-xl p-4 border border-red-200 flex items-center justify-center gap-2 transition-colors font-medium"
      >
        <LogOut className="w-5 h-5" />
        Sign Out
      </button>

      {/* Footer */}
      <div className="text-center pt-4 border-t border-accent-pink">
        <p className="text-text-medium text-xs">
          Daddy Time v1.0 • Made with 💖
        </p>
      </div>
    </div>
  );
}